import type { CatalogueEntry } from "../types";
import imageDark from "../images/abs-boundaries.dark.webp";
import imageLight from "../images/abs-boundaries.light.webp";

export const entry: CatalogueEntry = {
  slug: "abs-asgs-2026-main-structure",
  displayName: `ABS ASGS 2026 Main Structure & GCCSA`,
  datasetProductCode: `ABS-ASGS-2026-MAIN-STRUCTURE`,
  subtitle: `The Main Structure & GCCSA of the Australian Statistical Geography Standard (ASGS) Edition 4.`,
  shortDescription: `ABS ASGS 2026 Main Structure & GCCSA is a digital representation of the main structure of the 2026 edition of the Australian Statistical Geography Standard (ASGS) boundaries produced by the Australian Bureau of Statistics (ABS). The ASGS brings all the regions for which the ABS publishes statistics within the one framework, and a new edition is released for each Census. This product carries the 2026 main structure on its own, so it can be adopted independently of the earlier editions, which remain available in ABS Boundaries - Legacy. The Mesh Blocks released are used in building all ASGS boundaries.
The ABS ASGS 2026 Main Structure & GCCSA dataset includes:
-	2026 ABS Mesh Blocks and Statistical Areas`,
  metadata: {
    dateAdded: 1785542400000,
    dataType: ["Polygons"],
    totalFeatureCount: 487664,
    updateFrequency: `As Deemed Necessary`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://geoscape-australia-abs-mainstructure-2026-release.readthedocs-hosted.com/en/stable/`,
  productDescriptionLink: `https://geoscape-australia-docs-abs-boundaries-product-desc.readthedocs-hosted.com/en/stable/`,
  imageLight,
  imageDark,
  // "ABS Boundaries 2026" is kept so searches for the pre-rename name still find this entry.
  searchTags: `ABS ASGS Main Structure ABS Boundaries 2026 ASGS Areas Mesh Blocks Statistical Areas SA1 SA2 SA3 SA4 Greater Capital City Statistical Areas Census Census Mapping Demographic Study Geographic Analysis Statistical Reporting Stats`,
  detail: () =>
    import("../details/abs-asgs-2026-main-structure").then((m) => m.detail),
};

export default entry;
